import { render, staticRenderFns } from "./numberCombined.vue?vue&type=template&id=0970f0dc&scoped=true&"
import script from "./numberCombined.vue?vue&type=script&lang=js&"
export * from "./numberCombined.vue?vue&type=script&lang=js&"
import style0 from "./numberCombined.vue?vue&type=style&index=0&id=0970f0dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970f0dc",
  null
  
)

export default component.exports